import React from "react";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
interface SpeechBubbleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  n?: number; // 何階へ上がる/降りるか
  direction?: "up" | "down"; // 上がる or 降りる（デフォルト: up）
  variant?: "jump" | "return";
  animate?: boolean;
}

const SpeechBubbleButton: React.FC<SpeechBubbleButtonProps> = ({
  n,
  direction = "up",
  variant = "jump",
  animate = true,
  className = "",
  children,
  ...rest
}) => {
  // 翻訳インスタンスのインポート
  const { t } = useTranslation();

  const label =
    n !== undefined
      ? t(variant === "return" ? "階に戻る" : direction === "up" ? "階へ上がる" : "階へ下りる", {
          floor: n,
        })
      : children;
  const bubbleSizeClass = variant === "return" ? "px-3 py-1.5 text-base" : "px-4 py-2 text-lg";
  const iconSize = variant === "return" ? 14 : 16;
  const bubbleColors =
    variant === "return"
      ? { border: "var(--color-TextSecondary)", text: "var(--color-TextSecondary)", bg: "#f7f7f7" }
      : { border: "var(--color-MiraiPrimary)", text: "var(--color-MiraiPrimary)", bg: "#fff" };
  return (
    <button
      className={`group relative flex flex-col items-center focus:outline-none bg-transparent border-none p-0 ${animate ? "animate-bounce-slow" : ""} ${className}`}
      {...rest}
    >
      {/* bounce が button の transform を使うため、押下時の縮小は内側の吹き出しにかける */}
      <div
        className={`${bubbleSizeClass} rounded-[16px] border-2 font-bold font-sans shadow-sm transition-transform duration-150 group-active:scale-95`}
        style={{
          borderColor: bubbleColors.border,
          backgroundColor: bubbleColors.bg,
          color: bubbleColors.text,
        }}
      >
        <div className="flex items-center">
          {direction === "up" ? (
            <>
              {label}
              <IoIosArrowForward className="mr-1" size={iconSize} />
            </>
          ) : (
            <>
              <IoIosArrowBack className="mr-1" size={iconSize} />
              {label}
            </>
          )}
        </div>
      </div>
      {/* 吹き出しの三角マーク（小さめ） */}
      <div
        className="w-0 h-0 border-x-8 border-x-transparent border-t-8"
        style={{ borderTopColor: bubbleColors.border }}
      />
      <div
        className="w-0 h-0 -mt-2 border-x-7 border-x-transparent border-t-7"
        style={{ borderTopColor: bubbleColors.border }}
      />
    </button>
  );
};

export default SpeechBubbleButton;
